var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawNotifyDrs8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 955.454,
    height: 704.531,
    viewBox: "0 0 955.454 704.531",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-565 -203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.614,695.44,903,636.249s21.574,21.574,21.574,39.276L920.7,634.589s11.064,14.936,9.957,37.617S922.614,695.44,922.614,695.44Z",
    transform: "translate(544.487 210.584)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.317,668.327,419,576.837s33.347,33.347,33.347,60.708l-5.985-63.273s17.1,23.086,15.391,58.143S449.317,668.327,449.317,668.327Z",
    transform: "translate(440.621 152.34)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.536,693.243c.052,60.184-119.315,41.671-265.447,41.8S400.395,753.884,400.343,693.7s119.271-73.376,265.4-73.5c56.553-.049,108.834,1.866,152.076,7.775C885.3,637.193,929.5,656.351,929.536,693.243Z",
    transform: "translate(433.593 169.641)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 955.454,
    height: 2.753,
    transform: "translate(565 904.647)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.72,
    cy: 86.72,
    r: 86.72,
    transform: "translate(976.276 671.734)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.794,656.515a62.173,62.173,0,0,1-56.8-36.881L385.389,309.746A82.371,82.371,0,1,1,539.4,252.11l99.645,324.1a62.063,62.063,0,0,1-59.255,80.305Z",
    transform: "translate(425.288 9.057)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(645.437 435.988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.547,57.317l-8.026,30.6L157.92,81.9s12.04-22.073,9.03-32.107l29.6,7.525Z",
    transform: "translate(-131.264 -3.609)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.771 381.306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.479,468.09h18.428l8.766-71.079h-27.2Z",
    transform: "translate(-160.215 -397.011)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.456,469.526h0a15.824,15.824,0,0,1,.877,5.21h0a6.254,6.254,0,0,1-6.255,6.255H165.011a4.268,4.268,0,0,1-4.268-4.268v-2.376s-2.824-7.141,2.989-15.943c0,0,7.224,6.892,18.019-3.9l3.183-5.767,23.042,16.851,12.772,1.572c2.795.344,5.272-.054,6.709,2.368Z",
    transform: "translate(-160.057 -398.865)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.095,255.849,189.7,428.646H157.843l4.236-98.636,2.23-51.863-6.471-24.686a110.25,110.25,0,0,1-5.431-12.139c-2.8-7.506-5.01-16.506-1.728-20.772,1.207-1.574,4.348-2.737,8.616-3.6a89.16,89.16,0,0,1,8.918-1.269c18.841-1.864,45.639-.7,45.639-.7l.681,22.482.377,12.554.179,5.84Z",
    transform: "translate(-126.894 -9.169)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 373.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.811,459.354l18.232,2.679,19.013-69.049-26.908-3.954Z",
    transform: "translate(-126.24 -389.03)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.167,470.068h0a15.822,15.822,0,0,1,.11,5.281h0a6.255,6.255,0,0,1-7.1,5.279l-56.463-8.3a4.268,4.268,0,0,1-3.6-4.842l.346-2.35s-1.754-7.476,5.277-15.338c0,0,6.144,7.869,18.395-1.239l3.993-5.243,20.345,20.025,12.407,3.413c2.715.746,5.223.715,6.293,3.318h0Z",
    transform: "translate(-126.07 -390.975)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,226.871l-3.483,29.995-18.995,63.21L161.05,424.135,129.534,419.5,157.82,271.546l-2.8-25.37s-.913-2.522-1.958-6.215c-2.075-7.3-4.681-19.2-1.815-25.266a7.093,7.093,0,0,1,1.473-2.12c1.126-1.092,3.416-1.755,6.483-2.108,12.819-1.448,39.22,2.7,50.967,4.729l4.624,11.677Z",
    transform: "translate(-126.194 -9.011)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.118,79.877l34.615,43.643-6.213,45.5-5.325,46.3-62.708-9.531s13.544-32.608,15.05-34.113,5.285,2.212,2.642-2.657-5.653-4.868-3.144-7.377-19.565-35.116-19.565-52.674S157,77.367,157,77.367Z",
    transform: "translate(-126.802 -4.255)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.318,
    cy: 23.318,
    r: 23.318,
    transform: "translate(32.926 13.193)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321,81.208S184.81,53.6,185.428,45.57s11.951-20.564,11.951-20.564l8.029,6.484s6.794,0,2.161-9.882a19.92,19.92,0,0,0-13.279-11.427s-.625-7.888-16.683-6.345c-9.556.978-18.415,1.259-23.462,9.432l-4.425,11.738s-3.606,8.029-1.753,15.44-24.4,41.071-12.351,44.781,38.909,12.666,41.99,6.794a35.107,35.107,0,0,0,3.706-10.809Z",
    transform: "translate(-126.167 -0.113)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.768,150.739c4.451-3.7,3.35-12.363-2.459-19.358a22.756,22.756,0,0,0-8.536-6.528l-3.392-3.975L53.622,65.091S29.6,9.766,22.416,3.75A17.049,17.049,0,0,0,6.7.763L0,8.918,40.709,86.227l41.966,42.954,5.664,6.005a22.755,22.755,0,0,0,4.852,9.589c5.808,6.994,14.127,9.667,18.578,5.971Z",
    transform: "matrix(0.035, -0.999, 0.999, 0.035, 67.896, 114.386)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0S10.712,55.588,22.9,63.784l24.29-18.941s2.126-.091-1.831-4.56-2.943-14.065-2.943-14.065,1.78,2.3-2.094-.894S40.063.138,40.063.138Z",
    transform: "matrix(0.035, -0.999, 0.999, 0.035, 64.281, 116.801)",
    fill: "#e6e6e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawNotifyDrs8);
export default __webpack_public_path__ + "static/media/undraw_notify_drs8.efaddb0bf17e6ec4f28a7785f6dc1527.svg";
export { ForwardRef as ReactComponent };